import { render } from "./updateTel.vue?vue&type=template&id=ad94bd6a&scoped=true"
import script from "./updateTel.vue?vue&type=script&lang=js"
export * from "./updateTel.vue?vue&type=script&lang=js"

import "./updateTel.vue?vue&type=style&index=0&id=ad94bd6a&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad94bd6a"]])

export default __exports__